module.exports = __webpack_public_path__ + "img/L-bottom.d902cbf2.svg";